import React, { useState } from 'react';
import * as monacoEditor from 'monaco-editor';

import CodeEditorExpandable from '../CodeEditorExpandable';
import SchemaEditor from '../SchemaEditor';
import { CodeEditorSize } from '../CodeEditorExpandable/types';
import { MONACO_FULL_EDITOR_OPTIONS, MONACO_LITE_EDITOR_OPTIONS } from '../CodeEditorExpandable/const';
import { getDefaultIfUndefined } from '../../../utils/typeUtil';
import { CodeEditorStatus } from '../CodeEditor/types';
import { DEFAULT_EDITOR_STATUS } from '../CodeEditor/const';

import { DEFAULT_EDITOR_SIZE } from './const';

export interface ISchemaEditorExpandableProps {
  className?: string;
  value?: string;
  size?: CodeEditorSize;
  status?: CodeEditorStatus;
  readOnly?: boolean;
  codeFolder?: string;
  options?: monacoEditor.editor.IStandaloneEditorConstructionOptions;
  onBlur?: () => void;
  onChange?: (value?: string) => void;
  onValidate?: (errors: string[], status: CodeEditorStatus, value?: string) => void;
}

const SchemaEditorExpandable: React.FC<ISchemaEditorExpandableProps> = ({
  className,
  value,
  size = DEFAULT_EDITOR_SIZE,
  status = DEFAULT_EDITOR_STATUS,
  readOnly,
  codeFolder,
  options,
  onBlur,
  onChange,
  onValidate,
}) => {
  size = getDefaultIfUndefined(size, DEFAULT_EDITOR_SIZE);

  const [isFullscreen, setIsFullscreen] = useState(false);

  return (
    <CodeEditorExpandable
      className={className}
      isFullscreen={isFullscreen}
      readOnly={readOnly}
      size={size}
      status={status}
      onFullscreenToggle={setIsFullscreen}
    >
      <SchemaEditor
        codeFolder={codeFolder}
        isFullscreen={isFullscreen}
        options={options || isFullscreen ? MONACO_FULL_EDITOR_OPTIONS : MONACO_LITE_EDITOR_OPTIONS}
        readOnly={readOnly}
        value={value || ''}
        onBlur={onBlur}
        onChange={onChange}
        onValidate={onValidate}
      />
    </CodeEditorExpandable>
  );
};

export default SchemaEditorExpandable;
